/* וידאו 360° בכרטיסי מוצר (22/10/2026).
   מחשב (עכבר): מתנגן בריחוף. מגע (נייד): הכרטיס שבמרכז המסך מתנגן, אחד בכל פעם.
   הסרטון נטען רק כשצריך אותו (preload=none + data-src) ונחשף רק כשהוא באמת מתנגן,
   כדי שלא יהבהב ריבוע ריק. אחרי בחירת צבע אחר בכרטיס (variant_image_active) לא מנגנים —
   הסרטון בצבע הפתיחה. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var mouse = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var current = null;

  function start(v) {
    if (current && current !== v) stop(current);
    if (v.closest('.variant_image_active')) return;
    current = v;
    v.muted = true;
    if (!v.getAttribute('src')) v.src = v.dataset.src;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }

  function stop(v) {
    v.pause();
    v.classList.remove('is-playing');
    try { v.currentTime = 0; } catch (e) {}
    if (current === v) current = null;
  }

  document.addEventListener('playing', function (e) {
    var v = e.target;
    if (v.classList && v.classList.contains('card-video') && v === current) v.classList.add('is-playing');
  }, true);

  if (mouse) {
    document.addEventListener('mouseover', function (e) {
      var w = e.target.closest && e.target.closest('.card-wrapper');
      var v = w && w.querySelector('video.card-video');
      if (v && v !== current) start(v);
    });
    document.addEventListener('mouseout', function (e) {
      if (!current) return;
      var w = current.closest('.card-wrapper');
      if (!w || !w.contains(e.target)) return;
      if (e.relatedTarget && w.contains(e.relatedTarget)) return;
      stop(current);
    });
    return;
  }

  var conn = navigator.connection;
  if ((conn && conn.saveData) || !('IntersectionObserver' in window)) return;

  // רצועה במרכז המסך; מבין הכרטיסים שבתוכה — הקרוב ביותר למרכז.
  var inBand = new Set();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) inBand.add(en.target); else inBand.delete(en.target);
    });
    pick();
  }, { rootMargin: '-35% 0px -35% 0px', threshold: 0 });

  function pick() {
    var best = null, bestD = Infinity, cx = innerWidth / 2, cy = innerHeight / 2;
    inBand.forEach(function (v) {
      if (!v.isConnected) { inBand.delete(v); return; }
      var r = v.getBoundingClientRect();
      var d = Math.hypot(r.left + r.width / 2 - cx, r.top + r.height / 2 - cy);
      if (d < bestD) { bestD = d; best = v; }
    });
    if (best && best !== current) start(best);
    else if (!best && current) stop(current);
  }

  var ticking = false;
  addEventListener('scroll', function () {
    if (ticking || inBand.size < 2) return;
    ticking = true;
    requestAnimationFrame(function () { ticking = false; pick(); });
  }, { passive: true });

  function scan() {
    document.querySelectorAll('video.card-video:not([data-io])').forEach(function (v) {
      v.setAttribute('data-io', '');
      io.observe(v);
    });
  }
  // רשתות שנטענות מחדש (סינון, מיון, קרוסלות) מוסיפות כרטיסים חדשים
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; scan(); }, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
